export enum LinkableItemLifecycleStates {
    SELECTED = 'selected',
    IN_TRANSIT = 'inTransit',
    FINALIZED = 'finalized',
}

interface StateNode<T> {
    availableLifecycleStates: T[];
    name: T;
}

export interface LinkableItem {
    arrivalLocation: string;
    linkableItem: string;
    modifyPermanentLocation: boolean;
    state: StateNode<LinkableItemLifecycleStates>;
    linkableItemReferenceType: string;
}

export interface WorkflowSchema<T> {
    currentState: StateNode<T>;
    linkableItems: LinkableItem[];
}
